import { render, staticRenderFns } from "./FiBuMitgliederbeitaegeDetail.vue?vue&type=template&id=6dd7e826&"
import script from "./FiBuMitgliederbeitaegeDetail.vue?vue&type=script&lang=js&"
export * from "./FiBuMitgliederbeitaegeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports